<!--
  closable=false: o close() do PrimeNG (X, ESC, máscara) esconde o dialog antes de avisar. X, ESC e
  clique na máscara passam pelo cancel(), que respeita o loading.
-->
<p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [closable]="false"
  [style]="{ width: '520px', maxWidth: '96vw' }" position="top" styleClass="os-finish-dialog" maskStyleClass="os-dialog-mask">

  <ng-template #header>
    <div class="os-dialog-header">
      <div class="os-dialog-heading">
        <h2 class="os-dialog-title">{{ 'service-order.button-close' | translate }}</h2>
        <p class="os-dialog-subtitle">
          {{ 'service-order.finish-subtitle' | translate: {
            reference: serviceOrder.reference,
            installation: serviceOrder.installation.reference || ('service-order.not-informed' | translate)
          } }}
        </p>
      </div>
      <button type="button" class="os-head-close" (click)="cancel()"
        [attr.aria-label]="'service-order.close-dialog-label' | translate">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <form [formGroup]="form" class="os-dialog-body" (ngSubmit)="confirm()">
    <div class="os-finish-field" [class.os-finish-field--issues]="withIssues">
      <div class="os-finish-row">
        <label class="os-label" for="os-finish-notes">{{ 'service-order.close-notes-label' | translate }}</label>
        <span class="os-req-tag" [class.os-req-tag--required]="withIssues">
          {{ (withIssues ? 'service-order.tag-required' : 'service-order.tag-optional') | translate }}
        </span>
        <!-- Checkbox na linha do campo que ele muda: a tag ao lado já mostra a consequência -->
        <label class="os-issues-toggle" for="os-finish-issues">
          <input type="checkbox" id="os-finish-issues" formControlName="withIssues">
          {{ 'service-order.with-issues-label' | translate }}
          <i class="pi pi-info-circle os-issues-info" tabindex="0"
            [pTooltip]="'service-order.with-issues-tooltip' | translate" tooltipPosition="bottom"
            [attr.aria-label]="'service-order.with-issues-tooltip' | translate"></i>
        </label>
      </div>
      <textarea pTextarea id="os-finish-notes" class="w-full" formControlName="closeNotes" rows="4"
        [placeholder]="(withIssues ? 'service-order.close-notes-required-placeholder' : 'service-order.close-notes-placeholder') | translate"
        [class.p-invalid]="showError" [attr.aria-invalid]="showError"
        [attr.aria-describedby]="showError ? 'os-finish-error' : null"></textarea>
      @if (showError) {
      <span id="os-finish-error" class="os-field-error" role="alert">
        <i class="pi pi-exclamation-circle"></i>
        {{ 'service-order.close-notes-error' | translate }}
      </span>
      }
    </div>
  </form>

  <ng-template #footer>
    <div class="os-dialog-footer">
      @if (loading) {
      <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s"
        [style]="{ width: '32px', height: '32px' }" />
      } @else {
      <!-- Primário à esquerda, Cancelar à direita: padrão dos dialogs da tela -->
      <p-button [label]="(withIssues ? 'service-order.button-finish-with-issues' : 'service-order.button-close') | translate"
        icon="pi pi-flag-fill" [styleClass]="withIssues ? 'os-btn-issues' : 'btn-actions'" (onClick)="confirm()" />
      <p-button [label]="'service-order.button-cancel' | translate" severity="secondary" (onClick)="cancel()" />
      }
    </div>
  </ng-template>
</p-dialog>
